import { Record as record } from 'immutable';
import _ from 'lodash';

import { construct, resolve } from '../../../../src/helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import ValidationMixin from '../../../../src/records/ValidationMixin';
import validators from '../../../../src/validation';

import TicketEvidence from './TicketEvidence';

const fieldSchema = {
    outward: [resolve.as(TicketEvidence)],
    return: [resolve.as(TicketEvidence)]
};

export default class DayEvidence extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(DayEvidence, json, getResolvers(fieldSchema));
    }

    getComputedValues() {
        return {
            outward: _.result(this, 'outward.isComplete'),
            return: _.result(this, 'return.isComplete')
        };
    }

    getSchema() {
        return {
            outward: validators.true(),
            return: this.return ? validators.true() : validators.optional()
        };
    }

    setTicketType(direction, ticketType) {
        if (!ticketType) {
            return this.set(direction, null);
        } else if (
            ticketType.id !== this.getIn([direction, 'ticketType', 'id'])
        ) {
            return this.set(direction, new TicketEvidence({ticketType}));
        } else {
            return this;
        }
    }

    asEntriesList() {
        return this.toSeq().toMap().filter(Boolean).entrySeq().toList();
    }

    hasUpload() {
        return !_.isNil(this.getIn(['outward', 'file'])) || !_.isNil(this.getIn(['return', 'file']));
    }
}

Object.assign(DayEvidence.prototype, ValidationMixin);
